import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Modes de paiement',
  payment_options: {
    [PaymentMethod.Card]: 'Carte de crédit',
  },
};
